import React from 'react';

/** Zaglavlje ekrana: naslov (h2), kratak opis i akcije desno. */
export default function PageHeader({ title, subtitle, children }) {
    return (
        <div className="page-head">
            <div>
                <h2 className="page-title">{title}</h2>
                {subtitle && <p className="page-sub">{subtitle}</p>}
            </div>
            {children && <div className="page-actions">{children}</div>}
        </div>
    );
}

/** Prazno stanje: ikonica, naslov, objašnjenje i opciona akcija. */
export function EmptyState({ icon = 'pi pi-inbox', title, text, compact, children }) {
    return (
        <div className={`empty-state${compact ? ' compact' : ''}`} role="status">
            <span className="empty-icon" aria-hidden="true"><i className={icon} /></span>
            {title && <div className="empty-title">{title}</div>}
            {text && <div className="empty-text">{text}</div>}
            {children}
        </div>
    );
}

/** Poruka za praznu tabelu (DataTable emptyMessage). */
export const tableEmpty = (text, icon = 'pi pi-inbox') => (
    <div className="table-empty"><i className={icon} aria-hidden="true" />{text}</div>
);
